module.exports = __webpack_public_path__ + "static/media/userIcon.7ebc9462.svg";